// Import the Firebase SDK and services
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database"; // Import the database service

// Firebase config - replace with your Firebase credentials
const firebaseConfig = {
  apiKey: "AIzaSyAlZZtwkJPqifco2uiHLRgmxLpTQmgibSY",
  authDomain: "tedx-iit-jodhpur.firebaseapp.com",
  projectId: "tedx-iit-jodhpur",
  storageBucket: "tedx-iit-jodhpur.appspot.com",
  messagingSenderId: "789440101441",
  appId: "1:789440101441:web:dc2f14e4a16379f1915ac0",
  measurementId: "G-7R25E7707J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const database = getDatabase(app); // Initialize the database
